import { Title, Button } from '@gerdau/hefesto';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import useCanGoToPurchase from '../../hooks/useCanGoToPurchase';
import { ApplicationState } from '../../store';
import { ECustomerTypeView } from '../../store/ducks/user/types';
import { hasOnlyCGCustomerTypes } from '../../utils/commerceUser';
import { GetFlag } from '../../utils/featureFlag';
import useCmsBlockService from '../../services/MVP/useCmsBlockService';
import { parseBlockContent } from '../PageBuilder/parseBlockContent';
import {
  CloseButton,
  CloseIcon,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalImage
} from './styles';

export const CMS_BLOCK_ID = 'block-modal-floating';

const SESSION_KEY = 'market_communication_modal_closed';

const VALID_PAGES = [
  '/orders/long-steel',
  '/manifestation',
  '/financials',
  '/download-area'
];

const EXCLUDED_PAGES = [
  '/orders/long-steel/details',
  '/orders/long-steel/update'
];

const PURCHASE_PATH = '/purchase/commerce/steel-type-choose';

const MarketCommunicationModal: React.FC = () => {
  const [closed, setClosed] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === 'true'
  );

  const showFlag = GetFlag('market_communication_float');
  const isAdobeMode = GetFlag('market_communication_adobe');
  const canGoToPurchase = useCanGoToPurchase();
  const ordersInputCustomers = useSelector(
    (state: ApplicationState) => state.user.roles.ordersInputCustomers
  );
  const searchCustomerType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const customers = useSelector(
    (state: ApplicationState) => state.customers.customers
  );
  const history = useHistory();
  const location = useLocation();

  const isFabricationReceiver =
    searchCustomerType === ECustomerTypeView.FABRICATION_RECEIVER;
  const isOnValidPage =
    VALID_PAGES.some((page) => location.pathname.startsWith(page)) &&
    !EXCLUDED_PAGES.some((page) => location.pathname.startsWith(page));

  const shouldRender =
    !closed &&
    showFlag &&
    canGoToPurchase &&
    !isFabricationReceiver &&
    ordersInputCustomers.length > 0 &&
    !hasOnlyCGCustomerTypes(customers) &&
    isOnValidPage;

  const { content, loading } = useCmsBlockService(
    CMS_BLOCK_ID,
    shouldRender && isAdobeMode
  );

  const handleClose = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setClosed(true);
  };

  if (!shouldRender) return null;

  if (isAdobeMode) {
    if (loading || !content) return null;

    return (
      <ModalContainer>
        <CloseButton onClick={handleClose} aria-label="Fechar">
          <CloseIcon />
        </CloseButton>
        <div>{parseBlockContent({ html: content })}</div>
      </ModalContainer>
    );
  }

  const handleNavigate = () => {
    history.push(PURCHASE_PATH);
  };

  return (
    <ModalContainer>
      <ModalHeader>
        <Title level={3}>Pronto para o próximo pedido?</Title>
        <CloseButton onClick={handleClose} aria-label="Fechar">
          <CloseIcon />
        </CloseButton>
      </ModalHeader>
      <ModalContent>
        <p className="description">
          Ao confirmar pela plataforma, o pedido segue integrado ao processo.
          Disponível 24h.
        </p>
      </ModalContent>
      <ModalImage src="/market_banners/Flutuante.gif" alt="banner de compras" />
      <Button name="acessar-loja-modal" onClick={handleNavigate}>
        Acessar loja online
      </Button>
    </ModalContainer>
  );
};

export default MarketCommunicationModal;
